import { trigger, transition, state, style, animate } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

enum GroupState {
  Expanded = 'expanded',
  Collapsed = 'collapsed',
}

@Component({
  selector: 'app-expandable-group',
  templateUrl: './expandable-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('parent', [transition(':enter', [])]),
    trigger('expandCollapse', [
      state(GroupState.Collapsed, style({ height: '0' })),
      state(GroupState.Expanded, style({ height: '*' })),
      transition(`${GroupState.Collapsed} => ${GroupState.Expanded}`, animate('0.15s')),
      transition(`${GroupState.Expanded} => ${GroupState.Collapsed}`, animate('0.15s')),
    ]),
  ],
})
export class ExpandableGroupComponent {
  // Allows auto-tests to understand if the component is either expanded or collapsed and animation is done
  @HostBinding('attr.expansion-group-state')
  expandState: GroupState = GroupState.Collapsed;

  get expanded(): boolean {
    return this.expandState === GroupState.Expanded;
  }

  @Input()
  set expanded(value: boolean) {
    this.expandState = value ? GroupState.Expanded : GroupState.Collapsed;
  }

  @Input()
  isArrowHidden: boolean;

  @Output()
  animationDone = new EventEmitter<boolean>();

  toggle(): void {
    this.expandState = this.expanded ? GroupState.Collapsed : GroupState.Expanded;
  }

  onAnimationDone(): void {
    this.animationDone.emit(this.expanded);
  }
}
